import { useState, type ReactNode } from "react";
import { useIntl } from "react-intl";
import type { DocumentResource } from "@/lib/document-resource";
import { openDocumentResource } from "@/stores/document-preview-store";
import { userErrorMessage } from "@/lib/user-error";
import { DocumentThumbnail } from "./DocumentThumbnail";
import { DocumentOpenButton } from "./DocumentOpenButton";

export function DocumentRow({ file, name = file.name, detail, actions, onOpen, disabled, openLabel }: {
  file: DocumentResource; name?: string; detail?: ReactNode; actions?: ReactNode;
  onOpen?: () => void; disabled?: boolean; openLabel?: string;
}) {
  const intl = useIntl();
  const [error, setError] = useState<unknown>();
  return <div className="flex min-w-0 flex-1 items-center gap-3">
    <span className="smycles-field-label flex h-16 w-12 shrink-0 items-center justify-center rounded bg-ink/[0.06] uppercase tracking-wider text-ink ring-1 ring-ink/5">
      <DocumentThumbnail resource={file} compact fallback={<span aria-hidden>📄</span>} />
    </span>
    <div className="min-w-0 flex-1">
      <div className="truncate text-smycles-meta font-medium">{name}</div>
      {detail}
      {error ? <p role="alert" className="text-smycles-meta">{userErrorMessage(intl, error)}</p> : null}
    </div>
    <div className="flex shrink-0 items-center gap-1">
      <DocumentOpenButton resource={file} name={name} disabled={disabled} openLabel={openLabel} onOpen={onOpen ?? (() => {
        setError(undefined); void openDocumentResource(file).catch(setError);
      })} />
      {actions}
    </div>
  </div>;
}
